
function makeAppConfig() {
  const date = new Date();
  const year = date.getFullYear();

  // var GA_MK_version = "1.1.8";

  const AppConfig = {
    companyName : "Jazzba Inc.",
    addressLine1 : "2010 Winston Park Drive",
    addressLine2 : "Suit 200",
    city : "Oakville",
    state : "Ontario",
    zip : "L6H 5R7",
	countryAbbr : "US",
    country : "Canada",
    tollFree : "+1-888-305-5552",
    webSite : "jazzba.io",
    businessTaxNumber : "BN#762538916",
    salesKey : "123",

    // TODO: local urls
    //imagesBaseUrl: "https://anydatapoint.net/",
    imagesBaseUrl: "https://anydatapoint.net/",

    brandingFolder:"branding",

    /* ****************************************************************************
     *                                                                            *
     *    Set Following Variable for the LOCAL, DEV and COMMERCIAL environment    *
     *                      0                                                      *
     * ****************************************************************************/
 
    ENVIRONMENT:"COMMERCIAL", //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']

    /*URL Set For Local Environment*/

    LOCAL_RA_SERVICE:"https://raservice.jazzba.io/",
    LOCAL_CATALYST_SERVICE:"https://catalystservice.jazzba.io/api/v1/",
    LOCAL_CATALYST_APP:"https://catalyst.jazzba.io/",


    /*URL Set For DEV Environment*/

    // DEV CONFIGURATION
    DEV_RA_SERVICE:"https://raservice.jazzba.io/",
    DEV_CATALYST_SERVICE:"https://catalystservice.jazzba.io/api/v1/",
    DEV_CATALYST_APP:"https://catalyst.jazzba.io/",


    /*URL Set For COMMERCIAL Environment*/

    COMMERCIAL_RA_SERVICE:"https://raservice.jazzba.io/",
    COMMERCIAL_CATALYST_SERVICE:"https://catalystservice.jazzba.io/api/v1/",
    COMMERCIAL_CATALYST_APP:"https://catalyst.jazzba.io/",

        RA_SERVICE_API: "https://raservice.jazzba.io/",

    ApiURL_billing: "https://adppayus.jazzba.io/api/v1",
    WareHouseUrl: "https://istockus.jazzba.io",
    ApiURL_dt: "https://dtapius.jazzba.io/api/v1",
    java_image_uploader_url : "https://imageuploaderca.jazzba.io/api/v1",
    Monthly_License_alias:"ims",
    webStore_License_alias:"ws",
    WebStore_License_price:500,
    InventoryManagement_License_price:500,
    EDI_Integrations_License_price:0.6,
    EDI_Integrations_License_alias:"fulfilment-topup",
	ASN_License_alias:"asn",
	License_defaultTrialSubscription_Planid : "growing-business-trial-cad",
    chargebeeSiteName:"jazzba",
    chargebeeSiteApiKKey:"**secret**",
    prefix : "local",


//Todo we want api  route grouping based on module[e.g intellicommerce intellistock, intellicatalog]?, version?, region, application server URLs
    // jazzba global scripts ++zopim

    zopim_subdomain: 'whiztec.zendesk.com',

    storeURL:"https://istoreus.jazzba.io/?custId=",
	iRepURL:"https://irepus.jazzba.io",

    imageCutterSizes : "80x80,400x400",


    brand: 'JAZZ', // 'Material' old
      version:"2.5.264",

    user: 'Lisa',
    year,
    layoutBoxed: false,               // true, false
    navCollapsed: false,              // true, false
    navBehind: false,                 // true, false
    fixedHeader: false,                // true, false
    sidebarWidth: 'middle',           // small, middle, large
    theme: 'light',                   // light, gray, dark
    colorOption: '11',                // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    AutoCloseMobileNav: true,         // true, false. Automatically close sidenav on route change (Mobile only)
    productLink: '#'
    // productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
  };

  return AppConfig;
}

export function utcDateConverter(date) {
  return new Date(date).toDateString() + ' 00:00:00 GMT 0';
}

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/config.ts